import React,{useState,useEffect} from 'react'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'


function ActivityNav({activityType,activityDate}) {
 const [activityNavType,setActivityNavType] = useState(activityType)
const navigate = useNavigate()

 useEffect(()=>{
  setActivityNavType(activityType)
  console.log(activityType)
 },[activityType])

 const handleMenuLinkClick = (type) => {
  //change page to type
  navigate(`/activity/${type}/${activityDate}`)

 }
  return (
    <>
     <div className="menu menu-column menu-rounded menu-state-bg">
      <div className="menu-item mb-3">

             <span className={clsx('menu-link',{ active: activityNavType === 'all' })} onClick={()=>handleMenuLinkClick("all")} >
          <span className="menu-icon"><i className="bi bi-diagram-3 fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">All</span>
        </span>
        <span className={clsx('menu-link',{ active: activityNavType === 'reminder' })} onClick={()=>handleMenuLinkClick("reminder")} >
          <span className="menu-icon"><i className="bi bi-clock fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Reminders</span>
        </span>
        <span className={clsx('menu-link',{ active: activityNavType === 'recalls' })} onClick={()=>handleMenuLinkClick("recalls")} >
          <span className="menu-icon"><i className="bi bi-bootstrap-reboot fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Recalls</span>
        </span>
        <span className={clsx('menu-link',{ active: activityNavType === 'optical-lab' })} onClick={()=>handleMenuLinkClick("optical-lab")}  >
          <span className="menu-icon"><i className="bi bi-eyeglasses fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Optical Lab</span>
        </span>

        <span className={clsx('menu-link',{ active: activityNavType === 'summary' })} onClick={()=>handleMenuLinkClick("summary")} >
          <span className="menu-icon"><i className="bi bi-card-checklist fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Summary</span>
        </span>

         <span className={clsx('menu-link',{ active: activityNavType === 'welcome' })} onClick={()=>handleMenuLinkClick("welcome")} >
          <span className="menu-icon"><i className="bi bi-badge-wc fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Welcome</span>
        </span>

        <span className={clsx('menu-link',{ active: activityNavType === 'birthday' })} onClick={()=>handleMenuLinkClick("birthday")} >
          <span className="menu-icon"><i className="bi bi-cake fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Birthday</span>
        </span>

        <span className={clsx('menu-link',{ active: activityNavType === 'survey' })} onClick={()=>handleMenuLinkClick("survey")} >
          <span className="menu-icon"><i className="bi bi-clipboard-check fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Survey</span>
        </span>

        <span className={clsx('menu-link',{ active: activityNavType === 'thank-you' })} onClick={()=>handleMenuLinkClick("thank-you")} >
          <span className="menu-icon"><i className="bi bi-balloon fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Thank you</span>
        </span>

        <span className={clsx('menu-link',{ active: activityNavType === 'confirmation' })} onClick={()=>handleMenuLinkClick("confirmation")} >
          <span className="menu-icon"><i className="bi bi-calendar-check fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Confirmation</span>
        </span>

         <span className={clsx('menu-link',{ active: activityNavType === 'other' })} onClick={()=>handleMenuLinkClick("other")} >
          <span className="menu-icon"><i className="bi bi-asterisk fs-2 me-3"></i></span>
          <span className="menu-title fw-bold">Other</span>
        </span>

      </div>
    </div>
    </>
  )
}

export default ActivityNav